import type { TourStep } from '@/components/ui/Tour';
import { CLUB_PAGE_TOUR_STEP_IDS, TOUR_CENTERED_STEP_SELECTOR } from '../tour-constants';
import { TourStepContent } from './StepContent';

export const clubCalendarTourSteps: TourStep[] = [
  {
    content: (
      <TourStepContent
        title="Facility calendar"
        description="See court hire, closures, and play events in one place. Switch views to plan your facility day by day."
      />
    ),
    selectorId: TOUR_CENTERED_STEP_SELECTOR,
  },
  {
    content: (
      <TourStepContent
        title="Calendar views"
        description="Use list, monthly, weekly, or day views to review what's on each court and when."
      />
    ),
    selectorId: CLUB_PAGE_TOUR_STEP_IDS.CALENDAR_VIEW,
    position: 'bottom',
  },
  {
    content: (
      <TourStepContent
        title="Filters"
        description="Show or hide court hire, closures, and play events so the calendar matches what you need right now."
      />
    ),
    selectorId: CLUB_PAGE_TOUR_STEP_IDS.CALENDAR_FILTERS,
    position: 'top',
  },
];
